import { render, staticRenderFns } from "./PrivadoItinerarioRow.vue?vue&type=template&id=6bbd6dd0"
import script from "./PrivadoItinerarioRow.vue?vue&type=script&lang=js"
export * from "./PrivadoItinerarioRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports